<section class="flowpay-good-point-wrapper color-gray-light">
  <div class="box-container">
    <ng-container *ngFor="let item of loopArray(4); let i = index">
      <div class="box">
        <!-- image -->
        <div class="box__image">
          <picture>
            <source
              srcset="{{ 'https://flowaccountcdn.com/new_landing/image/functions/flowpay/icon_' + (i + 1) + '_v1.webp' }}"
              type="image/webp"
            />
            <source
              srcset="{{ 'https://flowaccountcdn.com/new_landing/image/functions/flowpay/icon_' + (i + 1) + '_v1.png' }}"
              type="image/png"
            />
            <img
              src="{{ 'https://flowaccountcdn.com/new_landing/image/functions/flowpay/icon_' + (i + 1) + '_v1.png' }}"
              alt="Billing note"
              title="Billing note"
              loading="lazy"
              width="60"
              height="60"
            />
          </picture>
        </div>
        <!-- title -->
        <div class="box__title">{{ 'FLOWPAY.GOOD_POINT.HEADING_' + (i + 1) + '.TITLE' | translate }}</div>
        <div class="box__detail">{{ 'FLOWPAY.GOOD_POINT.HEADING_' + (i + 1) + '.DETAIL' | translate }}</div>
      </div>
    </ng-container>
  </div>
</section>
